import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9a7e8a36&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7e8a36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a7e8a36')) {
      api.createRecord('9a7e8a36', component.options)
    } else {
      api.reload('9a7e8a36', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9a7e8a36&scoped=true&", function () {
      api.rerender('9a7e8a36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/monitoring/index.vue"
export default component.exports